import { lazy } from "react";
import * as boards from "./boards/index.js";

const l = (fn) => lazy(fn);

// Rutas de boards generadas desde el registro (src/boards/index.js)
const boardRoutes = Object.values(boards)
  .filter(({ enabled }) => enabled !== false)
  .map(({ path, component }) => ({
    path,
    Component: lazy(component),
  }));

export const publicRoutes = [
  { path: "/connect/:providerName/redirect", Component: l(() => import("./pages/others/LoginRedirect")) },
];

export const privateRoutes = [
  { path: "/home",                      Component: l(() => import("./pages/Home")) },
  { path: "/dashboard",                 Component: l(() => import("./pages/BusinessUnit/aluna/dashboards/HomeDashBoard")) },

  // Boards (auto-generadas desde src/boards/index.js)
  ...boardRoutes,

  // Aluna campaigns
  { path: "/campaign-creator",          Component: l(() => import("./pages/CampaignCreator/CampaignCreator")) },
  { path: "/edit-campaign",             Component: l(() => import("./pages/BusinessUnit/aluna/EditCampaign").then((m) => ({ default: m.EditCampaignAlunaPage }))) },

  // Roundler campaigns
  { path: "/roundler/campaign-creator", Component: l(() => import("./pages/CampaignCreator/CampaignCreator").then((m) => ({ default: m.CampaignCreatorRoundlerPage }))) },
  { path: "/roundler/edit-campaign",    Component: l(() => import("./pages/BusinessUnit/aluna/EditCampaign").then((m) => ({ default: m.EditCampaignRoundlerPage }))) },

  // Admin
  { path: "/admin",                     Component: l(() => import("./pages/Admin/AdminPanel")) },
  { path: "/admin/users-and-roles",     Component: l(() => import("./pages/Admin/Employees")) },

  // Dashboards & tools
  { path: "/incrusted",                 Component: l(() => import("./pages/BusinessUnit/aluna/dashboards/Incrusted")) },
  { path: "/clients-reports",           Component: l(() => import("./pages/BusinessUnit/aluna/dashboards/ClientsReports")) },
  { path: "/affiliates-reports",        Component: l(() => import("./pages/BusinessUnit/aluna/dashboards/AffiliatesReports")) },
];
